// Libs
import { createSelector } from 'reselect'
import _keyBy from 'lodash/keyBy'

// Selectors
import farms$ from 'fc-assets/src/selectors/farms'
import selectedFarmId$ from './selectedFarmId'

// Constants
import { PROP_ASSET_ID } from 'fc-model-assets'

export default createSelector(
  [
    selectedFarmId$,
    farms$,
  ],
  (farmId, farms) => {
    const assetsById = _keyBy(farms, PROP_ASSET_ID)
    if (farmId) {
      return assetsById[farmId]
    }

    return null
  })
